import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const NotFound = () => {
  const { t } = useTranslation()
  return (
    <Stack
      alignItems="center"
      spacing={2}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Typography
        variant="h1"
        color="text.disabled"
        sx={{ fontSize: '6rem', fontWeight: 700, lineHeight: 1 }}
      >
        404
      </Typography>
      <Typography variant="h5">{t('Page not found')}</Typography>
      <Typography variant="body1" color="text.secondary">
        {t('The page you are looking for does not exist or has been moved.')}
      </Typography>
    </Stack>
  )
}
